import { useMemo } from 'react';
import qs from 'query-string';
import { CollectorScope } from 'graphql/types';
import { useCollector } from './useCollector';

type CollectorInstallDetails = {
  name: string;
  imageSrc: string;
  installUrl: string;
  uninstallUrl: string;
};
export const useCollectorItem = (): {
  collectorId: string;
  scope: CollectorScope;
  refreshURL: string;
  loading: boolean;
  syncRequired: boolean;
  noAction: boolean;
  collectorMessage?: string;
  collectorItem: CollectorInstallDetails | null;
  redirectUrl?: string | undefined;
} => {
  const {
    id,
    scope,
    refreshURL,
    syncRequired,
    noAction,
    collectorMessage,
    redirectUrl
  } = qs.parse(window.location.search) as {
    id: string;
    scope: string;
    refreshURL: string;
    syncRequired?: string;
    noAction?: string;
    collectorMessage?: string;
    redirectUrl?: string | undefined;
  };
  const collectorScope = scope.toUpperCase() as CollectorScope;
  const { data, loading } = useCollector(id);
  const collector = data?.collector?.item;
  return useMemo(
    () => ({
      collectorId: id,
      loading,
      collectorItem: {
        name: collector?.name || '',
        imageSrc: collector?.image.src || '',
        installUrl:
          (collectorScope === CollectorScope.User
            ? collector?.userInstallURL
            : collector?.installURL) || '',
        uninstallUrl:
          (collectorScope === CollectorScope.User
            ? collector?.userUninstallURL
            : collector?.uninstallURL) || ''
      } as CollectorInstallDetails,
      scope: collectorScope,
      refreshURL: refreshURL,
      syncRequired: Boolean(syncRequired),
      noAction: Boolean(noAction),
      collectorMessage: collectorMessage,
      redirectUrl: redirectUrl
    }),
    [
      loading,
      collector,
      collectorScope,
      id,
      refreshURL,
      syncRequired,
      noAction,
      collectorMessage,
      redirectUrl
    ]
  );
};
